"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.payoutRoundUp = exports.round = void 0;
const ceil_1 = __importDefault(require("lodash/ceil"));
const floor_1 = __importDefault(require("lodash/floor"));
const round_1 = __importDefault(require("lodash/round"));
const round = function (value) {
  let precisionModifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  const SMALL_CONST_VALUE = 0.000000001;
  const valueToRound = value + SMALL_CONST_VALUE;
  return Math.round(valueToRound * precisionModifier) / precisionModifier;
};
exports.round = round;
const payoutRoundUp = value => {
  return value < 0 ? (0, floor_1.default)((0, round_1.default)(value, 4), 2) : (0, ceil_1.default)((0, round_1.default)(value, 4), 2);
};
exports.payoutRoundUp = payoutRoundUp;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsdURBQStCO0FBQy9CLHlEQUFpQztBQUNqQyx5REFBdUM7QUFFaEMsTUFBTSxLQUFLLEdBQUcsQ0FBQyxLQUFhLEVBQUUsaUJBQWlCLEdBQUcsR0FBRyxFQUFFLEVBQUU7SUFDNUQsTUFBTSxpQkFBaUIsR0FBRyxXQUFXLENBQUM7SUFDdEMsTUFBTSxZQUFZLEdBQUcsS0FBSyxHQUFHLGlCQUFpQixDQUFDO0lBRS9DLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxZQUFZLEdBQUcsaUJBQWlCLENBQUMsR0FBRyxpQkFBaUIsQ0FBQztBQUM1RSxDQUFDLENBQUM7QUFMVyxRQUFBLEtBQUssU0FLaEI7QUFFSyxNQUFNLGFBQWEsR0FBRyxDQUFDLEtBQWEsRUFBRSxFQUFFO0lBQzNDLE9BQU8sS0FBSyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBQSxlQUFLLEVBQUMsSUFBQSxlQUFXLEVBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFBLGNBQUksRUFBQyxJQUFBLGVBQVcsRUFBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUM7QUFDeEYsQ0FBQyxDQUFDO0FBRlcsUUFBQSxhQUFhLGlCQUV4QiJ9